export const PREVIEW_IMAGE_XLARGE_THRESHOLD = 2000;
export const PREVIEW_IMAGE_LARGE_THRESHOLD = 700;
export const PREVIEW_IMAGE_SMALL_THRESHOLD = 300;
export const PREVIEW_IMAGE_SCALE_XLARGE = 0.5;
export const PREVIEW_IMAGE_SCALE_LARGE = 0.7;
export const PREVIEW_IMAGE_SCALE_MEDIUM = 1.0;
export const PREVIEW_IMAGE_SCALE_SMALL = 1.5;

/**
 * 画像の自然サイズからプレビューモーダルの初期拡大率を返す
 * - XL（0.5倍）: 縦横いずれも 2000px 以上
 * - L（0.7倍）: 縦横いずれも 700px 以上
 * - S（1.5倍）: 縦横いずれも 300px 以下
 * - M（1.0倍）: それ以外
 */
export const calcPreviewImageInitialScale = (
  naturalWidth: number,
  naturalHeight: number,
): number => {
  if (
    naturalWidth >= PREVIEW_IMAGE_XLARGE_THRESHOLD &&
    naturalHeight >= PREVIEW_IMAGE_XLARGE_THRESHOLD
  ) {
    return PREVIEW_IMAGE_SCALE_XLARGE;
  }
  if (
    naturalWidth >= PREVIEW_IMAGE_LARGE_THRESHOLD &&
    naturalHeight >= PREVIEW_IMAGE_LARGE_THRESHOLD
  ) {
    return PREVIEW_IMAGE_SCALE_LARGE;
  }
  if (
    naturalWidth <= PREVIEW_IMAGE_SMALL_THRESHOLD &&
    naturalHeight <= PREVIEW_IMAGE_SMALL_THRESHOLD
  ) {
    return PREVIEW_IMAGE_SCALE_SMALL;
  }
  return PREVIEW_IMAGE_SCALE_MEDIUM;
};
